module.exports = __webpack_public_path__ + "04_long_gray.d7b80ba4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/04_long_gray.png
// module id = qXkP
// module chunks = 0